import { useContext, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Button, Typography } from '@mui/material';
import FormEntryStepper from './Entry/FormEntryStepper';
import FormEntry, { FormEntryRef } from './Entry/FormEntry';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext,
  WorkflowEngineMode
} from '../WorkflowEngine/workflowEngineReducer';
import HorizStepper from './Entry/FormEntryHorizStepper';
import { useResponsive } from '@abbott-components/core';
import { getFlag, post } from '../Shared/ajax';
import {
  SuspendDynamicWorkflowSynchronousRequest,
  SuspendDynamicWorkflowSynchronousResponse
} from './Entry/types';
import { useSnackbar } from 'notistack';
import { getErrorMessage } from '../Shared/errorHandling';
import config from '../Shared/config';
import FormPlaceHolder from './Entry/FormPlaceHolder';

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);
  const [defaultsLoaded, setDefaultsLoaded] = useState(false);
  const {
    pages,
    currentPage,
    mode,
    workflowName,
    workflowData,
    workflowEntryExternalId
  } = state;
  const page = pages[currentPage];
  const screenSize = useResponsive();
  const [isSuspendVisible, setIsSuspendVisible] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const submitBtnRef = useRef<FormEntryRef>(null);

  const handleStepSelection = (index: number) => {
    if (submitBtnRef.current) {
      submitBtnRef.current.submit(index);
    }
  };

  const handleSuspend = async () => {
    if (workflowEntryExternalId && config.workflowSuspensionSynchronousUrl) {
      setIsLoading(true);
      try {
        await post<
          SuspendDynamicWorkflowSynchronousResponse,
          SuspendDynamicWorkflowSynchronousRequest
        >(config.workflowSuspensionSynchronousUrl, {
          entryExternalId: workflowEntryExternalId,
          entryRole: config.role
        });
        if (config.workflowReturnUrl) {
          window.location.replace(config.workflowReturnUrl);
          return;
        }
      } catch (err) {
        if (config.workflowSuspensionSynchronousErrorMessage) {
          enqueueSnackbar(config.workflowSuspensionSynchronousErrorMessage, {
            variant: 'error'
          });
        } else {
          enqueueSnackbar('An unexpected error occurred', { variant: 'error' });
        }
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (workflowData.length > 0 && !defaultsLoaded) {
      dispatch({
        type: WorkflowEngineActionKind.SET_PAGE_VALID
      });
      if (config.role !== 'Donor') {
        getFlag('allow-dynamic-workflow-suspension-temp-27-AUG--2024').then(
          (_flagValue) => setIsSuspendVisible(_flagValue)
        );
      }
      setDefaultsLoaded(true);
    }
  }, [workflowData]);

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(`V${process.env.REACT_APP_VERSION}`);
  }, []);

  return (
    <>
      <Grid
        item
        xs={12}
        md={3}
        mt={{ md: mode === WorkflowEngineMode.ENTRY ? 5.5 : 0, sm: 0 }}
      >
        {screenSize.size.width > 0 && !screenSize.md ? null : (
          <FormEntryStepper handleStepSelection={handleStepSelection} />
        )}
      </Grid>
      <Grid item xs={12} md={9}>
        {mode === WorkflowEngineMode.ENTRY && (
          <Grid
            m={1}
            mt={0}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Typography variant="h1" component="h1">
              {workflowName}
            </Typography>
            {isSuspendVisible && (
              <Button
                type="button"
                variant="outlined"
                color="primary"
                onClick={handleSuspend}
              >
                {'Suspend Service'}
              </Button>
            )}
          </Grid>
        )}
        {screenSize.size.width > 0 && !screenSize.md ? <HorizStepper /> : null}
        {isLoading ? (
          <FormPlaceHolder {...page} />
        ) : (
          <FormEntry key={page.id} {...page} ref={submitBtnRef} />
        )}
      </Grid>
    </>
  );
};
